import { render } from "./TheServiceCenters.vue?vue&type=template&id=96460658"
import script from "./TheServiceCenters.vue?vue&type=script&lang=js"
export * from "./TheServiceCenters.vue?vue&type=script&lang=js"

import "./TheServiceCenters.vue?vue&type=style&index=0&id=96460658&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__